
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infopage/[...slug]",
      function () {
        return require("private-next-pages/infopage/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infopage/[...slug]"])
      });
    }
  